import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 弹窗广告定义
 */

// 终端类型
class PopUpAdvertTerminalType extends UltMeta {
    PC = new Meta(1, "PC");
    MOBILE = new Meta(2, "移动端");
}
export const POP_UP_ADVERT_TERMINAL_TYPE = new PopUpAdvertTerminalType();

/**
 *  适用终端
 */
class PopUpAdvertTerminal extends UltMeta {
    CHAIN_CLOUD_APP = new Meta(4, "链云APP");
    CHAIN_CLOUD_MINI_APP = new Meta(2, "链云小程序");
    SHIPPING_APP = new Meta(5, "船务APP");
    SHIPPING_MINI_APP = new Meta(3, "船务小程序");
    PC = new Meta(1, "PC");
}
export const POP_UP_ADVERT_TERMINAL = new PopUpAdvertTerminal();

/**
 *  适用终端
 */
class PopUpAdvertTerminalSand extends UltMeta {
    CHAIN_CLOUD_APP = new Meta(4, "链云APP");
    CHAIN_CLOUD_MINI_APP = new Meta(2, "链云小程序");
    PC = new Meta(1, "PC");
}
export const POP_UP_ADVERT_TERMINAL_SAND = new PopUpAdvertTerminalSand();

/**
 * 显示频率
 */
class PopUpADDisplayFrequency extends UltMeta {
    ONCE_DAILY = new Meta(1, "每天一次");
    ONCE_WEEKLY = new Meta(2, "每周一次");
    ONLY_ONCE = new Meta(3, "仅一次");
    EVERY_PAGE_OPEN = new Meta(4, "每次打开页面");
}
export const POP_UP_AD_DISPLAY_FREQUENCY = new PopUpADDisplayFrequency();

/**
 * 弹框广告  - 显示页面
 */
class PopUpADDisplayPage extends UltMeta {
    HOME = new Meta(1, "首页");
    SAND_INDEX_HOME = new Meta(2, "砂石指数首页");
    FREIGHT_INDEX_HOME = new Meta(3, "运价指数首页");
    NEWS_HOME = new Meta(4, "资讯首页");
    SHIP_SEARCH = new Meta(5, "查船页");
    VEHICLE_SEARCH = new Meta(6, "查车页");
    SHIPPING_DEMAND_LIST = new Meta(7, "船运需求列表");
    ORDER_PAGE = new Meta(8, "运单页");
    MEMBER_PAGE = new Meta(11, "会员页");
    CERTIFICATION_PAGE = new Meta(12, "认证页");
    ABOUT_US = new Meta(13, "关于我们");
}
export const POP_UP_AD_DISPLAY_PAGE = new PopUpADDisplayPage();

/** 弹框广告功能页 PC路径 */
class PopUpADFunctionPage extends UltMeta {
    SAND_GRAVEL_INDEX = new Meta("1", "砂石指数首页");
    FREIGHT_INDEX = new Meta("2", "运价指数首页");
    INFORMATION = new Meta("3", "资讯首页");
    CHECK_SHIP = new Meta("4", "查船页");
    CHECK_CAR = new Meta("5", "查车页");
    SHIPPING_NEED_LIST = new Meta("6", "船运需求列表");
    TRANSPORT_ORDER = new Meta("7", "运单页");
    MEMBER = new Meta("10", "会员页");
    AUTHENTICATION = new Meta("11", "认证页");
    ABOUT_US = new Meta("12", "关于我们");
}
export const POP_UP_AD_FUNCTION_PAGE = new PopUpADFunctionPage();

/**
 * 跳转类型
 */
class PopUpADDisplayType extends UltMeta {
    PRODUCT = new Meta(1, "商品");
    SAND_PRICE = new Meta(2, "砂价");
    FREIGHT_PRICE = new Meta(3, "运价");
    AD_PAGE = new Meta(4, "广告页");
    NEWS = new Meta(5, "资讯");
    FUNCTION_PAGE = new Meta(6, "功能页");
    LINK = new Meta(7, "链接");
}
export const POP_UP_AD_DISPLAY_TYPE = new PopUpADDisplayType();

/**
 * 状态
 */
class PopUpADState extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    ENABLED = new Meta(2, "启用");
    DISABLED = new Meta(3, "禁用");
}
export const POP_UP_AD_STATE = new PopUpADState();
